import type { FC } from "react";
import { useTranslation } from "@privacy/translations";
import { HoverPopover } from "./HoverPopover";
import { Stack, Typography } from "@mui/material";

export const MissingPermissionInfoPopover: FC<{ popoverProps: HoverPopover["popoverProps"] }> = ({ popoverProps }) => {
  const { t } = useTranslation();

  return (
    <HoverPopover {...popoverProps}>
      <Stack spacing={1} sx={{ p: 4, maxWidth: "20rem" }}>
        <Typography sx={{ fontSize: theme => theme.typography.pxToRem(12) }}>
          {t("MissingPermissionInfoPopover.Text")}
        </Typography>
      </Stack>
    </HoverPopover>
  );
};
